import { alpha, ChipProps, Components, lighten, Theme } from '@mui/material'

import Colors from '#/styles/Colors'

const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error', 'regular'] as const

export function OverridedChip(theme: Theme): Components {
  const rootStyle = (ownerState: ChipProps) => {
    const inheritColor = ownerState.color === undefined
    const softVariant = ownerState.variant === 'soft'

    const defaultStyle = {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      lineHeight: 'normal',
      whiteSpace: 'nowrap',
      ...(inheritColor && {
        ...(softVariant && {
          backgroundColor: alpha(theme.palette.grey[500], theme.palette.action.activatedOpacity),
          color: theme.palette.text.primary,
        }),
      }),
    }

    const colorStyle = COLORS.map(color => {
      if (ownerState.color === color) {
        const mainColor = Colors.feedback[color]?.color || theme.palette[color].main
        return {
          ...(ownerState.color === color && {
            ...(softVariant && {
              backgroundColor: Colors.feedback[color]?.background || lighten(mainColor, 0.85),
              color: mainColor,
            }),
          }),
        }
      }
    })

    const disabledState = {
      '&.Mui-disabled': {
        ...(softVariant && {
          backgroundColor: theme.palette.action.disabledBackground,
        }),
      },
    }

    return [...colorStyle, defaultStyle, disabledState]
  }

  return {
    MuiChip: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: ChipProps }) => rootStyle(ownerState),
        sizeMedium: {
          fontSize: '0.925em',
          height: '22px',
        },
        sizeSmall: {
          fontSize: '0.875em',
          height: '18px',
        },
      },
    },
  }
}
